import { SCENARIO_HYDRATE_RECEIVED } from '../actionTypes/asyncScenarioLoadActionTypes';

export const scenarioHydrateReceived = (
    scenario: any,
    { activeComparison, errors }: { activeComparison: any; errors?: any[] }
) => ({
    type: SCENARIO_HYDRATE_RECEIVED,
    payload: scenario,
    meta: {
        activeComparison,
        errors,
        isAsync: true
    }
});
